// extracted by mini-css-extract-plugin
export default {"Title":"RQDavCzh"};
    if(module.hot) {
      // 1776432162270
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  